<template>
  <div class="container">
    <div class="mt-2 card">
      <PatientInfo v-if="patient_id != null" :patient_id="patient_id">
        <template v-slot:action-bt>
          <button
            @click="showCreatePatientService"
            class="mycustom-success-button"
          >
            Add Scan
          </button>
        </template>
      </PatientInfo>
    </div>
  </div>
  <div v-if="loading">
    <loader />
  </div>
  <div v-if="!loading" class="container">
    <div class="mt-2 card">
      <table class="table align-items-center mb-0">
        <thead>
          <tr style="color: black">
            <th scope="col">Scan Number</th>
            <th scope="col">Scan Description</th>
            <th scope="col">Status</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="service in services" :key="service.id">
            <th scope="row">{{ service.id }}</th>
            <td style="color: black">{{ service.service_name }}</td>
            <td>
              {{
                service.attended == "0" || service.attended == null
                  ? "Pending..."
                  : service.attended == "2"
                  ? "Attended"
                  : "--"
              }}
            </td>
            <td>
              <span
                v-if="
                  open_service(
                    service.is_invoice,
                    service.is_paid,
                    cash_bills_behavior,
                  )
                "
              >
                <button
                  @click="handleShowAddScanModal(service.id)"
                  v-if="service.attended != 2"
                >
                  Conduct
                </button>
                .
              </span>

              <span
                v-if="
                  !open_service(
                    service.is_invoice,
                    service.is_paid,
                    cash_bills_behavior,
                  )
                "
                style="
                  color: black;
                  background-color: pink;
                  padding: 1px;
                  margin: 2px;
                "
              >
                !! Pending Payment !!
              </span>

              <button
                @click="removeScan(service.id)"
                v-if="service.attended != 2"
              >
                Remove/Delete Scan
              </button>
              .
              <!-- <button
                v-if="service.attended == 2"
                @click="triggerShowResultModal(service.id)"
              >
                View
              </button> -->
              <button
                v-if="service.attended == 2"
                @click="triggerShowResultModal(service.id)"
                style="
                  padding: 2px 14px;
                  background-color: #2563eb;
                  color: white;
                  border: none;
                  border-radius: 6px;
                  cursor: pointer;
                  font-size: 14px;
                  font-weight: 500;
                  transition: background-color 0.3s ease;
                "
                onmouseover="this.style.backgroundColor='#1d4ed8'"
                onmouseout="this.style.backgroundColor='#2563eb'"
              >
                View
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <AddRadiologyModal
    v-if="show_add_radiology_modal"
    @hide-create-rad-model="hideCreateScanModal"
    :service_id="current_scan"
  />

  <CreateServiceModal
    v-if="showAddServiceModal"
    :visitId="visit_id"
    @close-add-service-modal="showAddServiceModal = false"
  />
  <view_rad_result_modal
    v-if="showResultModal"
    :service_id="current_scan"
    @hide-view-result-modal="showResultModal = false"
  />
</template>

<script>
import PatientInfo from "../Patients/components/patient_biodata.vue";
import CreateServiceModal from "./add_patient_service_modal.vue";
import AddRadiologyModal from "./radiology/add_radiology_modal.vue";
import { generalApiRequest } from "../../api/apiIndex.js";
import view_rad_result_modal from "./radiology/view_rad_result_modal.vue";

import { get_setting } from "../../settings/get_setting.js";
import loader from "../special_clinics/dialysis/loader.vue";
import { open_service } from "../../settings/get_setting.js";

export default {
  name: "RadiologyDashboard",
  data() {
    return {
      showResultModal: false,
      show_add_radiology_modal: false,
      visit_id: this.$route.params.visitid,
      patient_id: null,
      showAddServiceModal: false,
      services: [], // Stores services for the current visit
      current_scan: "",
      cash_bills_behavior: 0,
      loading: false,
    };
  },
  components: {
    AddRadiologyModal,
    PatientInfo,
    CreateServiceModal,
    view_rad_result_modal,
    loader,
  },
  methods: {
    open_service,
    navigate_loc(route) {
      window.location.href = route;
    },

    handleShowAddScanModal(tid) {
      this.current_scan = tid;
      this.show_add_radiology_modal = true;
    },
    triggerShowResultModal(tid) {
      this.current_scan = tid;
      this.showResultModal = true;
    },

    hideCreateScanModal() {
      this.show_add_radiology_modal = false;
    },

    showCreatePatientService() {
      this.showAddServiceModal = true;
    },

    async fetchServicesForVisit() {
      this.loading = true;
      const url = `services/for-visit/${this.visit_id}` + "/3";
      try {
        const response = await generalApiRequest(url, "GET", {}, 1);
        console.log(response);

        this.services = response.data;
        const payment_setting = await get_setting("cash_bills_behavior");
        this.cash_bills_behavior = payment_setting.setting_value;
      } catch (error) {
        console.error("Error fetching services:", error);
      }
      this.loading = false;
    },

    async removeScan(serviceId) {
      const url = "services/delete/" + serviceId;
      const res = await generalApiRequest(url, "GET", {}, 1);
      if (res) {
        location.reload();
      }
    },

    async mountPastRecords() {
      const url = "get_all_visits_dates";
      const res = await generalApiRequest(
        url,
        "GET",
        { visit_id: this.visit_id },
        1,
      );
      this.past_records = res.data;
      if (res.data.length > 0) {
        this.patient_id = res.data[0].patient_id;
      }
    },
  },

  mounted() {
    this.mountPastRecords();
    this.fetchServicesForVisit();
  },
};
</script>

<style scoped>
td,
th {
  text-align: center;
  vertical-align: middle;
  padding: 8px;
  border-top: 1px solid #ddd;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  word-wrap: break-word;
}

td {
  padding: 8px;
  border: 1px solid #ddd;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  font-size: 16px;
  overflow: hidden;
}

@media (max-width: 768px) {
  td {
    font-size: 12px;
    padding: 6px;
  }
}

@media (max-width: 480px) {
  td {
    font-size: 10px;
    padding: 4px;
  }

  table {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
</style>
